/* eslint-disable */
import React, { useState } from 'react';
import '../styles/QuickLinks.css';

const QuickLinks = ({ currentPage, setCurrentPage }) => {
  const [setIsMobileMenuOpen] = useState(false);
  const quickLinks = [
    {
      icon: '💻',
      title: 'Online Services',
      description: 'Access our digital services portal for quick and convenient service delivery',
      link: 'services',
      color: '#2c5aa0'
    },
    {
      icon: '📋',
      title: 'Tenders',
      description: 'View current procurement opportunities and bidding documents',
      link: 'transparency',
      color: '#27ae60'
    },
    {
      icon: '💼',
      title: 'Job Opportunities',
      description: 'Explore career opportunities and join our dedicated team',
      link: 'careers',
      color: '#e74c3c'
    },
    {
      icon: '📊',
      title: 'Reports',
      description: 'Access latest reports, publications, and performance data',
      link: 'resources',
      color: '#9b59b6'
    },
    {
      icon: '🆘',
      title: 'Emergency Guidelines',
      description: 'Quick access to emergency protocols and response guidelines',
      link: 'contact',
      color: '#e67e22'
    },
    {
      icon: '📚',
      title: 'Resource Library',
      description: 'Browse our comprehensive collection of health resources',
      link: 'resources',
      color: '#34495e'
    }
  ];

  return (
    <section className="quick-links-section">
      <div className="container">
        <div className="section-header">
          <h2>Quick Access</h2>
          <p>Fast access to our most frequently used services and resources</p>
        </div>
        
        <div className="quick-links-grid">
          {quickLinks.map((link, index) => (
            <button key={index}
             onClick={() => {
                  setCurrentPage(link.link);
                  setIsMobileMenuOpen(false);
                  }}
            className="quick-link-card">
              <div 
                className="link-icon"
                style={{ backgroundColor: `${link.color}20`, color: link.color }}
              >
                <span>{link.icon}</span>
              </div>
              <div className="link-content">
                <h3>{link.title}</h3>
                <p>{link.description}</p>
              </div>
              <div className="link-arrow"
               >
                <span>→</span>
              </div>
            </button>
          ))}
        </div>

        <div className="quick-actions">
          <div className="action-item">
            <div className="action-icon">📞</div>
            <div className="action-content">
              <h4>Emergency Hotline</h4>
              <p>24/7 emergency response line</p>
              <div className="action-number">+211-924322221 </div>
            </div>
          </div>
          <div className="action-item">
            <div className="action-icon">🚨</div>
            <div className="action-content">
              <h4>Outbreak Alert</h4>
              <p>Report suspected disease outbreaks</p>
              <button className="action-btn">Report Now</button>
            </div>
          </div>
          <div className="action-item">
            <div className="action-icon">📰</div>
            <div className="action-content">
              <h4>Latest Updates</h4>
              <p>Stay informed with real-time updates</p>
              <button className="action-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickLinks;